export default __webpack_public_path__ + "static/snowflake-872b660fa06c6858501d0fa971510117.png";